import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Permit {
  PermitID: number;
  PermitName: string;
  UserRoleID: number;
  UserRoleName: string;
}

export interface DepartmentDetail {
  DepartmentID: number;
  DepartmentName: string;
  DepartmentImage: string;
  DepartmentDescription: string;
  Permits: Permit[];
}

export interface TownshipDetails {
  id: number;
  name: string;
  tagLine: string;
  description: string;
  departmentDetails: DepartmentDetail[];
}

export interface TownshipState {
  townshipDetails: TownshipDetails | null;
}

const initialState: TownshipState = {
  townshipDetails: null
};

const townshipSlice = createSlice({
  name: 'township',
  initialState,
  reducers: {
    setTownshipDetails: (state, action: PayloadAction<TownshipDetails>) => {
      state.townshipDetails = action.payload;
    },
    clearTownshipData: (state) => {
      state.townshipDetails = null; // Reset user details
    }
  }
});

export const { setTownshipDetails, clearTownshipData } = townshipSlice.actions;
export default townshipSlice.reducer;
